import React, { useEffect } from 'react';
import styled from 'styled-components';
import { getUser, showMenu, updateUser, useAppDispatch, userSelector } from '../../state';
import { useSelector } from 'react-redux';
import { BreadCrumbItem, LanguageSelector, OBreadCrumb } from '../molecules';
import { matchRoutes, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MenuItem, MenuItemCommandEvent } from 'primereact/menuitem';
import { ProfileMenu } from './ProfileMenu';
import { useAuth } from 'react-oidc-context';
import { Button } from 'primereact/button';

interface Props {
}


export const Header: React.FC<Props> = (props) => {
    const dispatch = useAppDispatch();
    let auth = useAuth();

    const {t} = useTranslation();
    let navigation = useNavigate();
    console.log('QQQ auth.user?.access_token: ', auth.user?.access_token);
    useEffect(() => {
        dispatch(getUser({jwtToken: auth.user?.access_token!}));
    }, [auth.user?.access_token]);
    let user = useSelector(userSelector).singleItem;

    const breadCrumbConfig: BreadCrumbItem[] = [
        {
            label: t('screens.credentialDetail.title'),
            path: '/credential/details/:credentialId',
            parent: {
                label: t('screens.credentialList.title'),
                path: '/'
            }
        }
    ];

    const breadCrumb = matchRoutes(breadCrumbConfig, useLocation())?.at(0);


    function updateLanguage(locale: string) {
        dispatch(updateUser({jwtToken: auth.user?.access_token!, locale: locale, userPreferences: user?.userPreferences}));
    }

    const items: MenuItem[] = [
        {
            label: t('menu.apiDocs'),
            icon: 'pi pi-book',
            command(event: MenuItemCommandEvent) {
                window.location.replace('/api/public/swagger-ui');
            }
        },
        {
            label: t('menu.apiKey'),
            icon: 'pi pi-key',
            command(event: MenuItemCommandEvent) {
                navigation('/apiKey');
            }
        },
        {
            label: t('menu.logoff'),
            icon: 'pi pi-sign-out',
            command(event: MenuItemCommandEvent) {
                auth.signoutRedirect({post_logout_redirect_uri: window.location.origin + '/'});
            }
        }
    ];

    return (
        <div className="col-12 pl-4 pr-4 flex align-items-center justify-content-between" style={{minHeight: '68px'}}>
            <div className="mr-2 block xl:hidden"><Button icon="pi pi-bars" link onClick={() => {
                dispatch(showMenu(true))
            }}/></div>
            {(breadCrumb?.route) && (<OBreadCrumb breadCrumb={breadCrumb?.route}/>)}
            {(breadCrumb?.route === undefined) && (
                <div className="flex flex-column">
                    <div className="font-semibold">Wallet admin</div>
                </div>)}
            {/*<Menubar className="flex justify-content-end bg-white-alpha-90 border-0" model={items}></Menubar>*/}
            {/*<div>*/}
            {/*    <div className="hidden sm:inline mr-1">sm</div>*/}
            {/*    <div className="hidden md:inline mr-1">md</div>*/}
            {/*    <div className="hidden lg:inline mr-1">lg</div>*/}
            {/*    <div className="hidden xl:inline mr-1">xl</div>*/}
            {/*    <div className="hidden xxl:inline mr-1">xxl</div>*/}
            {/*</div>*/}
            <div className="flex flex-end">
                <LanguageSelector selectedLocale={user?.locale} onLocaleSelected={locale => {
                    updateLanguage(locale);
                }}/>
                <ProfileMenu menuItems={items}/>
            </div>

        </div>
    );

};

const Root = styled.div`
    display: flex;
    min-height: 68px;
    justify-content: flex-end;
    align-items: center;
`;

